import type { FormField } from '../../interfaces/form.interface';
import { DropdownData, InputType } from '../../interfaces/input.interface';
import { ReactiveFormValueUtils } from '../../model/reactive-form-value.utils';

/** Keeps DropdownData.selected in sync with the Angular control value. */
export class DropdownSelectedValueService<T> {
    public applySelected(field: FormField<T> | undefined, value: unknown): void {
        const dropdownData = field?.input.data as DropdownData<T> | undefined;

        if (!dropdownData) {
            return;
        }

        if (this.isMultiSelect(field)) {
            dropdownData.selected = (Array.isArray(value) ? value : []) as T;
            return;
        }

        dropdownData.selected = this.normalizeSingleSelectedValue(value);
    }

    private normalizeSingleSelectedValue(value: unknown): T | null {
        if (!ReactiveFormValueUtils.hasNonEmptyValue(value)) {
            return null;
        }

        return value as T;
    }

    private isMultiSelect(field: FormField<T> | undefined): boolean {
        return field?.input?.type === InputType.MULTISELECT_SEARCH || field?.input?.type === InputType.MULTISELECT;
    }
}
